"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelDetailsItem = void 0;
const react_1 = __importDefault(require("react"));
const labelDetailsItem_css_1 = require("./labelDetailsItem.css");
const LabelDetailsItem = ({ label, details }) => react_1.default.createElement("div", { className: labelDetailsItem_css_1.container },
    react_1.default.createElement("div", { className: labelDetailsItem_css_1.labelContainer, "data-test-id": "fds-table-label-details-item-label" }, label),
    details && react_1.default.createElement("div", { className: labelDetailsItem_css_1.detailsContainer, "data-test-id": "fds-table-label-details-item-details" }, Array.isArray(details)
        ? details.map((detail, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index },
            react_1.default.createElement("span", null, detail),
            index < details.length - 1 && react_1.default.createElement("span", null, "\u2022"))))
        : details));
exports.LabelDetailsItem = LabelDetailsItem;
